import { createSlice } from '@reduxjs/toolkit';
// import { Action } from 'history';
import _, { parseInt } from 'lodash';
// import sum from 'lodash/sum';
// import uniqBy from 'lodash/uniqBy';

// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  name: null,
  description: null,
  id: null,
  items: [],
  activeItem: null,
};

const getItem = (id, items) => _.find(items, { id });

const slice = createSlice({
  name: 'checklist',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CHECKLIST
    getChecklistSuccess(state, action) {
      state = action.payload;
      state.isLoading = false;
    },

    clearChecklist(state) {
      Object.assign(state, initialState);
    },
    deleteChecklistItem(state, action) {
      state.items.splice(
        _.findIndex(state.items, (o) => o.id === action.payload),
        1
      );
    },

    copyChecklistItem(state, action) {
      const item = _.cloneDeep(_.find(state.items, (o) => o.answer.id === action.payload.index));
      item.answer.id = action.payload.id;
      state.items.push(item);
    },
    addNewChecklistItem(state, action) {
      const { id, defaultValue } = action.payload;
      // console.log(action.payload);
      switch (action.payload.type) {
        case 'text':
          state.items.splice(action.payload.index || state.items.length, 0, {
            question: '',
            id,
            attachImage: false,
            require: true,
            answer: {
              type: 'text',
              value: defaultValue,
            },
          });
          break;
        case 'image':
          state.items.splice(action.payload.index || state.items.length, 0, {
            question: '',
            id,
            attachImage: true,
            require: true,
            answer: {
              type: 'image',
              value: defaultValue,
            },
          });
          break;
        case 'option':
          state.items.splice(action.payload.index || state.items.length, 0, {
            question: '',
            attachImage: false,
            require: true,
            id,
            answer: {
              type: 'option',
              value: defaultValue,
            },
          });
          break;
        case 'checkbox':
          state.items.splice(action.payload.index || state.items.length, 0, {
            question: '',
            id,
            attachImage: false,
            require: true,
            answer: {
              type: 'checkbox',
              value: defaultValue,
            },
          });
          break;
        case 'dropdown':
          state.items.splice(action.payload.index || state.items.length, 0, {
            question: '',
            id,
            attachImage: false,
            require: true,
            answer: {
              type: 'dropdown',
              value: defaultValue,
            },
          });
          break;
        case 'section':
          state.items.splice(action.payload.index || state.items.length, 0, {
            question: '',
            id,
            attachImage: false,
            require: true,
            answer: {
              type: 'section',
              value: defaultValue,
            },
          });
          break;
        default:
          break;
      }
      state.activeItem = id;
    },
    updateItemQuestion(state, action) {
      const item = getItem(action.payload.index, state.items);
      if (item) item.question = action.payload.question;
    },
    updateItemAnswer(state, action) {
      // console.log(action.payload);
      const item = getItem(action.payload.index, state.items);
      item.answer.value = action.payload.answer;
    },
    updateChecklistOrder(state, action) {
      state.items = action.payload.map((v) => state.items[parseInt(v)]);
    },
    setActiveChecklistItem(state, action) {
      if (action.payload !== state.activeItem) state.activeItem = action.payload;
    },
    setState(state, action) {
      state = Object.assign(state, action.payload);
    },
    setStateItem(state, action) {
      const item = getItem(action.payload.id, state.items);
      Object.assign(item, action.payload.data);
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getChecklistSuccess,
  deleteChecklistItem,
  copyChecklistItem,
  addNewChecklistItem,
  updateItemQuestion,
  updateItemAnswer,
  orderChecklistItems,
  updateChecklistOrder,
  setActiveChecklistItem,
  setState,
  setStateItem,
  clearChecklist,
} = slice.actions;

// ----------------------------------------------------------------------

export function getChecklist(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/checklists/${id}`);
      dispatch(slice.actions.getChecklistSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
